import i18n from 'i18next';

export default ({ isInLiveMode, isChildLocale = false }) => ({
  ...(!isInLiveMode && !isChildLocale && {
    is_active: {
      type: 'Boolean',
      label: i18n.t('status'),
      labelText: i18n.t('active'),
      placeholder: i18n.t('untitled-category'),
    }
  }),
  ...(isInLiveMode && !isChildLocale && {
    status: {
      type: 'Select',
      label: i18n.t('status'),
      selectProps: {
        isFluid: true,
        isFullWidth: true,
      },
      options: ['open', 'closed', 'canceled'].map((key, i) => (
        { id: i, label: i18n.t(key), value: key }
      )),    
    }
  }),
  name: {
    type: 'Text',
    label: i18n.t('title'),
    placeholder: i18n.t('title-of-video'),
    validators: [{ type: 'isRequired' }, { type: 'isNotEmptyString' }],
  },
  ...(!isInLiveMode && {
    caption: {
      type: 'Upload',
      label: i18n.t('captions'),
      help: i18n.t('captions-help'),
      hasRemoveUploadButton: true,
      hasReplaceUploadButton: true,
      maxUploadSize: 10,
      removeUploadButtonText: i18n.t('remove-caption'),
      replaceUploadButtonText: i18n.t('upload-new-caption'),
      uploadButtonText: i18n.t('upload-caption'),
      uploadType: 'document',
      permittedFormats: '.vtt',
    },
  }),
  ...(!isChildLocale && {
    is_locale_master: {
      type: 'Boolean',
      label: i18n.t('additional-locale-display'),
      labelText: i18n.t('show-for-missing-locales'),
      help: i18n.t('additional-locale-display-help'),
    },
  }),
});
